var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.207 4.207a.65.65 0 0 1 .92 0l5.556 5.557V4.667a.65.65 0 1 1 1.3 0v6.666a.65.65 0 0 1-.65.65H4.667a.65.65 0 1 1 0-1.3h5.097L4.207 5.126a.65.65 0 0 1 0-.919Z",
    fill: "currentColor"
  })));
};

export { Svg16 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjIwNzA0IDQuMjA3MDVDNC40NjA4OCAzLjk1MzIxIDQuODcyNDQgMy45NTMyMSA1LjEyNjI4IDQuMjA3MDVMMTAuNjgzMyA5Ljc2NDFMMTAuNjgzMyA0LjY2NjY3QzEwLjY4MzMgNC4zMDc2OSAxMC45NzQzIDQuMDE2NjcgMTEuMzMzMyA0LjAxNjY3QzExLjY5MjMgNC4wMTY2NyAxMS45ODMzIDQuMzA3NjkgMTEuOTgzMyA0LjY2NjY3TDExLjk4MzMgMTEuMzMzM0MxMS45ODMzIDExLjY5MjMgMTEuNjkyMyAxMS45ODMzIDExLjMzMzMgMTEuOTgzM0w0LjY2NjY2IDExLjk4MzNDNC4zMDc2OCAxMS45ODMzIDQuMDE2NjYgMTEuNjkyMyA0LjAxNjY2IDExLjMzMzNDNC4wMTY2NiAxMC45NzQ0IDQuMzA3NjggMTAuNjgzMyA0LjY2NjY2IDEwLjY4MzNMOS43NjQwOSAxMC42ODMzTDQuMjA3MDQgNS4xMjYyOUMzLjk1MzIgNC44NzI0NSAzLjk1MzIgNC40NjA4OSA0LjIwNzA0IDQuMjA3MDVaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";